import React from 'react'
import { FC } from 'react'
import { DataGridCell } from '@imodules/react-components/controls/DataGridCell'

export interface HeaderCellProps {
    cellName: string
    displayCell: boolean
    fixedWidth: string
    headerText: string
    defaultSortAscending: boolean
    sortDirection: 'Ascending' | 'Descending' | 'Unsorted'
    sortLeaderboard: (sortAscending: boolean) => () => void
}

export const HeaderCell: FC<HeaderCellProps> = props => (
    <>
        {props.displayCell && <DataGridCell
            className={`scoreboard-${props.cellName}-column column-header data-grid-column${props.sortDirection === 'Unsorted' ? '' : props.sortDirection === 'Descending' ? ' sorted-desc' : ' sorted-asc'}`}
            isColumnHeader={true}
            onClick={() => props.sortLeaderboard(props.sortDirection === 'Unsorted' ? props.defaultSortAscending : props.sortDirection !== 'Ascending')()}
            widthType={{ kind: 'fixedWidth', fixedWidth: props.fixedWidth }}
        > {props.headerText}
        </DataGridCell>}
    </>
)

export interface DesignationHeaderCellProps {
    headerText: string
    sortDirection: 'Ascending' | 'Descending' | 'Unsorted'
    sortLeaderboard: (sortAscending: boolean) => () => void
}

export const DesignationHeaderCell: FC<DesignationHeaderCellProps> = props => {
    const { headerText, sortLeaderboard } = props
    return (<DataGridCell
        className={`scoreboard-designation-column column-header data-grid-column${props.sortDirection === 'Unsorted' ? '' : props.sortDirection === 'Descending' ? ' sorted-desc' : ' sorted-asc'}`}
        widthType={{ kind: 'width', width: 1 }}
        onClick={() => sortLeaderboard(props.sortDirection !== 'Ascending')()}
        isColumnHeader={true}
    >
        {headerText}
    </DataGridCell >)
}

export interface LeaderboardHeaderRowProps {
    layoutSettings: LeaderboardLayoutSettingsDto
    sortedColumn: { column: keyof SortableLeaderboardDataRecord, direction: 'Ascending' | 'Descending' }
    sortLeaderboard: (column: keyof SortableLeaderboardDataRecord) => (sortAscending: boolean) => () => void
    scoreboardTypeId: number
}

export const LeaderboardHeaderRow: FC<LeaderboardHeaderRowProps> = props => {
    const { displayRank,
        displayDollarsRaised,
        rankHeaderText,
        designationsHeaderText,
        dollarsRaisedHeaderText,
        displayDonors,
        donorsHeaderText,
        rankPosition,
        designationsPosition,
        donorsPosition,
        dollarsRaisedPosition,
        displayBonusAmount,
        displayPercentageOfDollars,
        displayPercentageOfParticipation,
        bonusAmountHeaderText,
        percentageOfDollarsHeaderText,
        percentageOfParticipationHeaderText,
        bonusAmountPosition,
        percentageOfDollarsPosition,
        percentageOfParticipationPosition,
        displayPercentageOfGoals,
        percentageOfGoalsPosition,
        percentageOfGoalsHeaderText,
        displayGoals,
        goalsPosition,
        goalsHeaderText
    } = props.layoutSettings
    const scoreboardTypeId = props.scoreboardTypeId
    const columns = [
        { position: rankPosition, component: <HeaderCell sortLeaderboard={props.sortLeaderboard('rank')} defaultSortAscending={true} sortDirection={props.sortedColumn.column === 'rank' as any ? props.sortedColumn.direction : 'Unsorted'} key="rank" fixedWidth="7%" cellName="rank" displayCell={displayRank} headerText={rankHeaderText} /> },
        { position: designationsPosition, component: <DesignationHeaderCell sortLeaderboard={props.sortLeaderboard('name')} sortDirection={props.sortedColumn.column === 'name' ? props.sortedColumn.direction : 'Unsorted'} key="designation" headerText={designationsHeaderText} /> },
        { position: donorsPosition, component: <HeaderCell sortLeaderboard={props.sortLeaderboard('recordCount')} defaultSortAscending={false} sortDirection={props.sortedColumn.column === 'recordCount' ? props.sortedColumn.direction : 'Unsorted'} key="donors" fixedWidth="15%" cellName="donors" displayCell={displayDonors} headerText={donorsHeaderText} /> },
        { position: dollarsRaisedPosition, component: <HeaderCell sortLeaderboard={props.sortLeaderboard('totalDollars')} defaultSortAscending={false} sortDirection={props.sortedColumn.column === 'totalDollars' ? props.sortedColumn.direction : 'Unsorted'} key="dollars" fixedWidth="20%" cellName="dollars" displayCell={displayDollarsRaised} headerText={dollarsRaisedHeaderText} /> },
        { position: percentageOfDollarsPosition, component: <HeaderCell sortLeaderboard={props.sortLeaderboard('percentageOfAllGifts')} defaultSortAscending={false} sortDirection={props.sortedColumn.column === 'percentageOfAllGifts' ? props.sortedColumn.direction : 'Unsorted'} key="percentageDollars" fixedWidth="15%" cellName="percentageDollars" displayCell={displayPercentageOfDollars && scoreboardTypeId === 13} headerText={percentageOfDollarsHeaderText} /> },
        { position: bonusAmountPosition, component: <HeaderCell sortLeaderboard={props.sortLeaderboard('calculatedBonus')} defaultSortAscending={false} sortDirection={props.sortedColumn.column === 'calculatedBonus' ? props.sortedColumn.direction : 'Unsorted'} key="bonus" fixedWidth="15%" cellName="bonus" displayCell={displayBonusAmount} headerText={bonusAmountHeaderText} /> },
        { position: percentageOfParticipationPosition, component: <HeaderCell sortLeaderboard={props.sortLeaderboard('percentageOfAllContributers')} defaultSortAscending={false} sortDirection={props.sortedColumn.column === 'percentageOfAllContributers' ? props.sortedColumn.direction : 'Unsorted'} key="percentageParticipation" fixedWidth="15%" cellName="percentageParticipation" displayCell={displayPercentageOfParticipation} headerText={percentageOfParticipationHeaderText} /> },
        { position: percentageOfGoalsPosition, component: <HeaderCell sortLeaderboard={props.sortLeaderboard('percentageOfGoal')} defaultSortAscending={false} sortDirection={props.sortedColumn.column === 'percentageOfGoal' ? props.sortedColumn.direction : 'Unsorted'} key="percentageGoal" fixedWidth="15%" cellName="percentageGoal" displayCell={displayPercentageOfGoals} headerText={percentageOfGoalsHeaderText} /> },
        { position: goalsPosition, component: <HeaderCell sortLeaderboard={props.sortLeaderboard('goalAmount')} defaultSortAscending={false} sortDirection={props.sortedColumn.column === 'goalAmount' ? props.sortedColumn.direction : 'Unsorted'} key="goals" fixedWidth="15%" cellName="goals" displayCell={displayGoals} headerText={goalsHeaderText} /> },


    ]
    return (
        <ul className="data-grid-row">
            {columns.sort((x, y) => x.position - y.position).map(x => x.component)}
        </ul >)
}
